import type { ChecklistData } from "./types";

export const CHECKLISTS_DATA: ChecklistData[] = [
  {
    id: "pistolet-zakup-checklist",
    title: "Checklista zakupowa: pistolet",
    type: "broń krótka",
    fases: [
      {
        title: "Przygotowanie przed wyjazdem",
        description:
          "Zbierz niezbędne dokumenty i akcesoria, aby legalnie dokonać zakupu i bezpiecznie transportować broń.",
        items: [
          {
            title: "Promesa zakupu broni",
            info: "Dokument wydany przez Policję (WPA) potwierdzający prawo do nabycia broni. Bez niego sprzedaż jest niemożliwa.",
          },
          {
            title: "Dowód osobisty lub paszport",
            info: "Niezbędny do weryfikacji tożsamości i wpisania danych do faktury lub umowy.",
          },
          {
            title: "Legitymacja posiadacza broni",
            info: "Wymagana do zakupu amunicji. Jeśli kupujesz pierwszą broń, wystarczy dowód osobisty i promesa.",
          },
          {
            title: "Pokrowiec, torba lub futerał",
            info: "Zapewnia bezpieczny i dyskretny transport. Pamiętaj o obowiązku przemieszczania broni w sposób jak najmniej rzucający się w oczy.",
          },
          {
            title: "Środki płatnicze",
            info: "Sprawdź metody płatności. Przy transakcjach prywatnych zazwyczaj wymagana jest gotówka.",
          },
        ],
      },
      {
        title: "Oględziny wizualne i mechaniczne",
        description:
          "Dokładnie sprawdź stan techniczny pod kątem zużycia, usterek i zgodności prawnej.",
        items: [
          {
            title: "Numer seryjny i zgodność dokumentacji",
            info: "Sprawdź numery na zamku, szkielecie i lufie. Muszą być zgodne z promesą i książeczką sprzedającego.",
          },
          {
            title: "Lufa i przewód lufy",
            info: "Sprawdź pod światło: brak korozji (wżerów), zmatowień i rozdęć. Gwint powinien być ostry i wyraźny.",
          },
          {
            title: "Mechanizm spustowy i bezpieczniki",
            info: "Sprawdź 'na sucho': płynność pracy, wyraźny reset oraz poprawne działanie bezpieczników nastawnych i wewnętrznych.",
          },
          {
            title: "Prowadnice zamka i pasowanie",
            info: "Brak nadmiernych luzów między zamkiem a szkieletem. Sprawdź stan zużycia powłoki na styku części ruchomych.",
          },
          {
            title: "Magazynki i przyrządy celownicze",
            info: "Sprawdź stan szczęk magazynka i płynność pracy podajnika. Skontroluj, czy przyrządy celownicze nie są obluzowane.",
          },
          {
            title: "Analiza modelu i ergonomia",
            info: "Sprawdź typowe usterki danego modelu w sieci. Upewnij się, że chwyt i manipulatorzy pasują do Twojej dłoni.",
          },
        ],
      },
      {
        title: "Test funkcyjny i finalizacja",
        description: "Potwierdź działanie mechaniczne i zabezpiecz transakcję od strony prawnej.",
        items: [
          {
            title: "Test strzelecki (jeśli możliwe)",
            info: "Na strzelnicy sprawdź: cykliczność przeładowania, zatrzymanie zamka w tylnym położeniu i celność.",
          },
          {
            title: "Faktura lub umowa kupna-sprzedaży",
            info: "Podstawa do rejestracji broni w WPA (masz na to 5 dni kalendarzowych).",
          },
          {
            title: "Kompletność zestawu i gwarancja",
            info: "Sprawdź obecność kufra, instrukcji, dodatkowych nakładek chwytu i karty gwarancyjnej.",
          },
        ],
      },
    ],
    verdict: {
      negotiate: [
        "Drobne zarysowania powłoki (kosmetyka)",
        "Starsza data produkcji przy braku przebiegu",
        "Brak zapasowych magazynków w zestawie",
        "Cena powyżej średniej rynkowej",
      ],
      stop: [
        "Wżery, korozja lub 'wytyrana' lufa",
        "Pęknięcia szkieletu lub istotne luzy na prowadnicach",
        "Niezgodność numerów seryjnych z dokumentacją",
        "Zacięcia (Failure to Feed / Failure to Fire) podczas testu strzeleckiego",
        "Brak dowodu zakupu lub podejrzane pochodzenie",
      ],
    },
    footer:
      "Pamiętaj o rejestracji broni w WPA w ciągu 5 dni od zakupu (liczą się dni kalendarzowe). Bezpieczeństwo jest priorytetem.",
  },
  {
    id: "karabinek-ar15-ak-checklist",
    title: "Checklista zakupowa: karabin (AR-15 / AK)",
    type: "broń długa",
    fases: [
      {
        title: "Przygotowanie przed wyjazdem",
        description:
          "Zbierz niezbędne dokumenty i akcesoria, aby legalnie dokonać zakupu i bezpiecznie transportować broń.",
        items: [
          {
            title: "Promesa zakupu broni",
            info: "Dokument z WPA. Upewnij się, że obejmuje broń centralnego zapłonu w odpowiednim kalibrze.",
          },
          {
            title: "Dowód osobisty lub paszport",
            info: "Niezbędny do weryfikacji tożsamości i wpisania danych do faktury lub umowy.",
          },
          {
            title: "Legitymacja posiadacza broni",
            info: "Wymagana do zakupu amunicji. Jeśli kupujesz pierwszą broń, wystarczy dowód osobisty i promesa.",
          },
          {
            title: "Pokrowiec, torba lub futerał",
            info: "Wymagany do bezpiecznego transportu karabinka z punktu zakupu.",
          },
          {
            title: "Narzędzia inspekcyjne (latarka, bore-light)",
            info: "Niezbędne do dokładnego sprawdzenia długiej lufy i wnętrza komory zamkowej.",
          },
          {
            title: "Środki płatnicze",
            info: "Sprawdź metody płatności. Przy transakcjach prywatnych zazwyczaj wymagana jest gotówka.",
          },
        ],
      },
      {
        title: "Oględziny wizualne i mechaniczne",
        description:
          "Dokładnie sprawdź stan techniczny pod kątem zużycia, usterek i zgodności prawnej.",
        items: [
          {
            title: "Numer seryjny i zgodność dokumentacji",
            info: "AR: sprawdź lufę, zamek i komory (upper/lower); AK: sprawdź komorę zamkową, suwadło i zamek.",
          },
          {
            title: "Lufa, korona i urządzenie wylotowe",
            info: "Sprawdź skok gwintu, czystość przewodu lufy i stan korony (wpływa na celność). Brak rdzy w rurze gazowej.",
          },
          {
            title: "Zespół ruchomy (zespół suwadła i zamka)",
            info: "AR: stan pierścieni uszczelniających, klucza gazowego i iglicy. AK: osiowość tłoka i stan rygli zamka.",
          },
          {
            title: "Mechanizm spustowy i selektor ognia",
            info: "Sprawdź pracę spustu, działanie bezpiecznika oraz czy mechanizm nie 'przepuszcza' przy wymuszonym resecie.",
          },
          {
            title: "Pasowanie części (Upper/Lower lub Gazówka)",
            info: "AR: luz między komorami (akceptowalny do pewnego stopnia). AK: stabilność rury gazowej i łoża.",
          },
          {
            title: "Standardy i kompatybilność (Mil-Spec)",
            info: "Sprawdź, czy karabinek trzyma standardy wymiarowe, co ułatwi przyszły tuning i serwis.",
          },
        ],
      },
      {
        title: "Test funkcyjny i finalizacja",
        description: "Potwierdź działanie mechaniczne i zabezpiecz transakcję od strony prawnej.",
        items: [
          {
            title: "Test strzelecki (jeśli możliwe)",
            info: "Sprawdź skupienie (np. poniżej 2 MOA dla AR) oraz niezawodność wyrzutu łusek i podawania naboju.",
          },
          {
            title: "Faktura lub umowa kupna-sprzedaży",
            info: "Podstawa do rejestracji broni w WPA (5 dni kalendarzowych). Sprawdź, czy kaliber na fakturze zgadza się z wybitym na broni.",
          },
          {
            title: "Akcesoria i dodatki",
            info: "Sprawdź obecność magazynków (np. PMAG), zestawu do czyszczenia lub oszynowania w zestawie.",
          },
        ],
      },
    ],
    verdict: {
      negotiate: [
        "Brak standardu Mil-Spec przy dobrej jakości wykonania",
        "Zarysowania na oszynowaniu (handguardzie)",
        "Brak zapasowych magazynków",
        "Cena wyższa niż rynkowa (porównaj oferty)",
      ],
      stop: [
        "Korozja w lufie lub bloku gazowym",
        "Nadmierne luzy zespołu suwadła (BCG) sugerujące ekstremalne zużycie",
        "Pęknięcia na ryglach zamka lub czole zamka",
        "Niestabilne cyklowanie (zacięcia) podczas testu",
        "Ślady niefachowych przeróbek lub napraw",
      ],
    },
    footer:
      "AR-15 to modularność i precyzja, AK to prostota i niezawodność. Rejestracja w WPA obowiązkowa w ciągu 5 dni (kalendarzowych).",
  },
  {
    id: "strzelba-zakup-checklist",
    title: "Checklista zakupowa: strzelba",
    type: "strzelba",
    fases: [
      {
        title: "Przygotowanie przed wyjazdem",
        description:
          "Zbierz niezbędne dokumenty i akcesoria, aby legalnie dokonać zakupu i bezpiecznie transportować broń.",
        items: [
          {
            title: "Promesa zakupu broni",
            info: "Wydana przez Policję. Musi uwzględniać broń gładkolufową (np. kaliber 12/76).",
          },
          {
            title: "Dowód osobisty lub paszport",
            info: "Niezbędny do weryfikacji tożsamości przy transakcji.",
          },
          {
            title: "Legitymacja posiadacza broni",
            info: "Wymagana do zakupu amunicji. Jeśli kupujesz pierwszą broń, wystarczy dowód osobisty i promesa.",
          },
          {
            title: "Pokrowiec lub futerał",
            info: "Wymagany do bezpiecznego i dyskretnego transportu broni długiej.",
          },
          {
            title: "Latarka i czysta szmatka",
            info: "Do sprawdzenia lustra lufy – w strzelbach gładki przewód lufy jest kluczowy.",
          },
          {
            title: "Środki płatnicze",
            info: "Sprawdź metody płatności. Przy transakcjach prywatnych zazwyczaj wymagana jest gotówka.",
          },
        ],
      },
      {
        title: "Oględziny wizualne i mechaniczne",
        description:
          "Dokładnie sprawdź stan techniczny pod kątem zużycia, usterek i zgodności prawnej.",
        items: [
          {
            title: "Numer seryjny i zgodność dokumentacji",
            info: "Sprawdź numer na komorze zamkowej i lufie (jeśli lufa jest wymienna).",
          },
          {
            title: "Przewód lufy i czoki",
            info: "Brak wgnieceń z zewnątrz i wżerów wewnątrz. Sprawdź, czy gwinty czoków są czyste i nie są zapieczone.",
          },
          {
            title: "Mechanizm ryglowania i czółenko",
            info: "Pump-action: płynny ruch czółenka. Łamana: brak luzów na baskili (tzw. klekotania).",
          },
          {
            title: "Spust i bezpiecznik",
            info: "Praca spustu bez nadmiernego oporu i 'haczenia'. Bezpiecznik musi pewnie blokować mechanizm.",
          },
          {
            title: "Kolba, osada i ergonomia",
            info: "Brak pęknięć (szczególnie przy szyjce kolby). Sprawdź długość kolby (LOP) i dopasowanie do policzka.",
          },
          {
            title: "Magazynek i system podawania",
            info: "Sprawdź drożność magazynka rurowego i stan łyżki podającej. Zgodność z limitami pojemności (jeśli dotyczy).",
          },
        ],
      },
      {
        title: "Test funkcyjny i finalizacja",
        description: "Potwierdź działanie mechaniczne i zabezpiecz transakcję od strony prawnej.",
        items: [
          {
            title: "Test strzelecki (jeśli możliwe)",
            info: "Sprawdź pokrycie śrutem i powtarzalność na brenece. Skontroluj siłę wyrzutu łusek (ekstraktor/eżektor).",
          },
          {
            title: "Faktura lub umowa kupna-sprzedaży",
            info: "Podstawa do rejestracji w WPA w ciągu 5 dni (kalendarzowych).",
          },
          {
            title: "Akcesoria (czoki, klucze)",
            info: "Upewnij się, że otrzymujesz zestaw wymiennych czoków i dedykowany do nich klucz (jeżeli są w zestawie).",
          },
        ],
      },
    ],
    verdict: {
      negotiate: [
        "Drobne obicia na drewnianej osadzie",
        "Brak czoków w zestawie",
        "Starszy model przy niskim przebiegu",
        "Cena powyżej średniej rynkowej",
      ],
      stop: [
        "Wgniecenia w ściance lufy lub głęboka korozja",
        "Luz (klekot) na połączeniu lufy z baskilą (broń łamana)",
        "Pęknięcia konstrukcyjne kolby",
        "Niewypały lub problemy z ekstrakcją łusek",
        "Niezgodność numerów seryjnych",
      ],
    },
    footer:
      "Wybierz model dopasowany do dyscypliny (trap, skeet, dynamika). Rejestracja w WPA w ciągu 5 dni (kalendarzowych).",
  },
  {
    id: "sztucer-308-checklist",
    title: "Checklista zakupowa: sztucer (Karabin powtarzalny)",
    type: "karabin",
    fases: [
      {
        title: "Przygotowanie przed wyjazdem",
        description:
          "Zbierz niezbędne dokumenty i akcesoria, aby legalnie dokonać zakupu i bezpiecznie transportować broń.",
        items: [
          {
            title: "Promesa zakupu broni",
            info: "Dokument z WPA. Musi pozwalać na zakup broni kulowej w danym kalibrze (np. .308 Win).",
          },
          {
            title: "Dowód osobisty lub paszport",
            info: "Niezbędny do weryfikacji tożsamości i wystawienia dokumentów sprzedaży.",
          },
          {
            title: "Legitymacja posiadacza broni",
            info: "Wymagana do zakupu amunicji. Jeśli kupujesz pierwszą broń, wystarczy dowód osobisty i promesa.",
          },
          {
            title: "Pokrowiec lub sztywny futerał",
            info: "Kluczowy dla ochrony precyzyjnej lufy i optyki podczas transportu. Pamiętaj o obowiązku przemieszczania broni w sposób jak najmniej rzucający się w oczy.",
          },
          {
            title: "Latarka, bore-light i ewentualnie boroskop",
            info: "Niezbędne do oceny stanu komory nabojowej i lufy.",
          },
          {
            title: "Środki płatnicze",
            info: "Sprawdź metody płatności. Przy transakcjach prywatnych zazwyczaj wymagana jest gotówka.",
          },
        ],
      },
      {
        title: "Oględziny wizualne i mechaniczne",
        description:
          "Dokładnie sprawdź stan techniczny pod kątem zużycia, usterek i zgodności prawnej.",
        items: [
          {
            title: "Numer seryjny i zgodność dokumentacji",
            info: "Sprawdź numery na komorze (systemie) i lufie. Muszą zgadzać się z fakturą/umową.",
          },
          {
            title: "Lufa: Przewód, pola i bruzdy",
            info: "Klucz do precyzji. Szukaj wyraźnego gwintu i braku wypalenia stożka przejściowego (throat erosion).",
          },
          {
            title: "Zamek, ryglowanie i czoło zamka",
            info: "Płynna praca zamka (tzw. cycling). Czoło zamka bez śladów nadmiernych ciśnień czy erozji od spłonek.",
          },
          {
            title: "Spust (opór i charakterystyka)",
            info: "Powinien być powtarzalny i 'szklany'. Sprawdź działanie przyspiesznika, jeśli model go posiada.",
          },
          {
            title: "Osada i 'bedding'",
            info: "Lufa powinna być samonośna (free-floating). Sprawdź, czy osada nie dotyka lufy i czy nie ma pęknięć.",
          },
          {
            title: "Komora nabojowa i blokada rygli",
            info: "Sprawdź, czy nie ma śladów korozji w komorze, co mogłoby powodować problemy z ekstrakcją.",
          },
        ],
      },
      {
        title: "Test funkcyjny i finalizacja",
        description: "Potwierdź działanie mechaniczne i zabezpiecz transakcję od strony prawnej.",
        items: [
          {
            title: "Test strzelecki (skupienie)",
            info: "Dla sztucera kluczowe jest skupienie (np. sub-MOA). Sprawdź, czy grupy nie 'wędrują' wraz z rozgrzaniem lufy.",
          },
          {
            title: "Faktura lub umowa kupna-sprzedaży",
            info: "Podstawa do rejestracji w WPA. Zachowaj do celów gwarancyjnych.",
          },
          {
            title: "Dodatki (montaż, magazynki)",
            info: "Sprawdź jakość szyny montażowej i działanie zatrzasku magazynka wypinanego.",
          },
        ],
      },
    ],
    verdict: {
      negotiate: [
        "Drobne rysy na osadzie lub oksydzie",
        "Lekkie zużycie stożka przejściowego (przy broni używanej)",
        "Brak gwintu na końcu lufy pod urządzenie wylotowe",
        "Cena powyżej średniej rynkowej",
      ],
      stop: [
        "Wypalona lufa lub wyraźna korozja w przewodzie",
        "Niepoprawny dystans czoła zamka (headspace)",
        "Pęknięta osada w miejscach kluczowych dla celności",
        "Skupienie drastycznie odbiegające od deklarowanego (np. >2 MOA)",
        "Niezgodność numerów istotnych części broni",
      ],
    },
    footer:
      "Wybierz kaliber i skok gwintu pod konkretny rodzaj amunicji/zwierzyny. Rejestracja w WPA w ciągu 5 dni (kalendarzowych).",
  },
];
